export default "__VITE_ASSET__DOD4tNKC__"